import { StaticImage } from "gatsby-plugin-image"

import { Seo } from "@trueskin-web/components"

import MoneyBack from "../../../components/choose-plan/components/money-back"
import PageHeader from "../../shared/choose-plan/page-header"
import Products from "../../shared/choose-plan/products"
import Testimonials from "../../shared/choose-plan/testimonials"
import FAQs from "../../shared/faqs"
import Plans from "../components/plans"
import { dataV1, products } from "../data"

import withPresets from "./with-presets"

const PlansWithPresets = withPresets(Plans, dataV1.plans)

const ProductImage = (
  <StaticImage
    src="../../../../images/rebranded/rebranded-product-set.png"
    alt=""
    sx={{
      display: "block",
      background: "#F5F5F5",
    }}
    data-component-name="web-portal-plan-selection-products-image"
  />
)

const ChoosePlanV1 = () => {
  return (
    <div sx={{ maxWidth: "468px", mx: "auto" }}>
      <Seo title="Wähle dein Paket aus" />
      <PageHeader
        heading={
          <span
            sx={{
              fontFamily: "display",
              fontSize: 4,
              lineHeight: "smallerHeading",
            }}
          >
            Freu Dich auf sichtbar bessere Haut mit FORMEL SKIN!
          </span>
        }
        sx={{
          my: 5,
        }}
      />
      <Products
        heading="Deine 3-Step-Routine mit effektiven Wirkstoffen für beste Ergebnisse"
        image={ProductImage}
        products={products}
      />
      <PlansWithPresets subscription={dataV1.subscription} />
      <MoneyBack sx={{ background: "lightBlue" }} />
      <Testimonials
        title={
          <span
            sx={{
              fontFamily: "display",
              fontSize: 3,
            }}
          >
            Echte Menschen – Echte Erfolge
          </span>
        }
        description="Nach nur 6-8 Behandlungswochen feiern unsere Patient*innen erste sichtbare Erfolge."
        name={
          <>
            <span sx={{ fontWeight: "bold" }}>Lotta</span>, Akne-Patientin bei
            FORMEL SKIN
          </>
        }
        labelAfter="Nach 2 Monaten"
      />
      <FAQs
        title={<span sx={{ fontFamily: "display" }}>FAQs</span>}
        items={dataV1.faq}
      />
    </div>
  )
}

export default ChoosePlanV1
